export default class SlotCounter {
  static readonly registry = { total: 0 }

  static increment(slot: SlotClass): number {
    this.registry.total++

    return this.registry[slot]
      ? ++this.registry[slot]
      : (this.registry[slot] = 1)
  }

  static current(slot: SlotClass): number {
    return this.registry[slot] ? this.registry[slot] : (this.registry[slot] = 1)
  }
}
